export default () => {
  return {
    currentStep: 0,
    totalSteps: 10,
  }
}
